module.exports = __webpack_public_path__ + "img/icon2.873ca4dd.svg";